<template>
  <div class="frisbuy-interaction-wrapper" ref="frame">
    <slot></slot>
  </div>
</template>

<script>
export default {
  mounted() {
    this.handleResizeGuidelines();

    window.addEventListener("resize", this.handleResizeGuidelines);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResizeGuidelines);
  },

  methods: {
    handleResizeGuidelines() {
      this.$nextTick(() => {
        /* [BUG]
          setInterval is needed for check offsetWidth.
          ".frisbuy-interaction-wrapper" can not to get offsetWidth in first check
        */
        const checkForSizeInterval = setInterval(() => {
          const subW = this.$refs?.frame?.offsetWidth / 400;

          if (subW > 0) {
            document.documentElement.style.setProperty(
              "--frisbuy-interaction-width",
              subW
            );

            clearInterval(checkForSizeInterval);
          }
        }, 250);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap");

.frisbuy-interaction-wrapper {
  position: absolute;
  inset: 0;

  width: unset;
  height: unset;
  max-width: 100%;
  max-height: 100%;
  aspect-ratio: 9 / 16;
  margin: auto;
}
</style>
